// services/baseQuery.js
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout, setCredentials } from "../slices/authSlice";

const apiUrl = process.env.REACT_APP_API_URL;

const baseQuery = fetchBaseQuery({
  baseUrl: apiUrl,
  prepareHeaders: (headers) => {
    const storedAuth = JSON.parse(localStorage.getItem("auth"));
    const token = storedAuth?.token;
    console.log({ token });
    if (token) {
      headers.set("Authorization", `${token}`);
    }

    return headers;
  },
});

const customBaseQuery = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    console.log("Access token expired. Trying refresh token...");

    const refreshToken = JSON.parse(localStorage.getItem("auth"))?.refreshToken;
    const userData = JSON.parse(localStorage.getItem("auth"))?.userData;
    const refreshResult = await baseQuery(
      {
        url: "/auth/refresh-token",
        method: "POST",
        body: { refreshToken },
      },
      api,
      extraOptions
    );

    if (refreshResult?.data) {
      // Update localStorage and Redux state with new tokens
      api.dispatch(
        setCredentials({ ...refreshResult.data?.data, userData: userData })
      );
      console.log({ refreshResult });
      localStorage.setItem(
        "auth",
        JSON.stringify({ ...refreshResult.data?.data, userData: userData })
      );

      // Retry original request
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logout());
      localStorage.removeItem("auth");
    }
  }

  return result;
};

export default customBaseQuery;
